import { useEffect, useState } from 'react';

export function useIsNetworkOnline() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  useEffect(() => {
    const online = setIsOnline.bind(null, true);
    const offline = setIsOnline.bind(null, false);
    window.addEventListener('online', online);
    window.addEventListener('offline', offline);
    return () => {
      window.removeEventListener('online', online);
      window.removeEventListener('offline', offline);
    };
  }, []);
  return isOnline;
}
